/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Box } from "@material-ui/core";
import { ApiKeysReducer, ApplicationState } from "../../../../data/interfaces";
import { PreLoaderLogo } from "../../../../elements/PreLoaderLogo";
import React from "react";
import { connect } from "react-redux";

interface LoaderProps {
    apiKeysReducer: ApiKeysReducer;
}

function Loader(props: LoaderProps) {
    const { apiKeysReducer } = props;
    const isLoading = apiKeysReducer.isLoading;

    const LoadingLogo = () => {
        return (
            <React.Fragment>
                <Box
                    justifyContent="center"
                    alignItems="center"
                    display="flex"
                    height="50vh"
                >
                    <PreLoaderLogo size="medium" />
                </Box>
            </React.Fragment>
        );
    }
    
    if (!isLoading) {
        return null;
    }

    return (
        <LoadingLogo />
    );
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        apiKeysReducer: state.apiKeysReducer,
    }
}

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(Loader);
